import Vue from 'vue'
import ErrorPage from 'vue-error-page'
import VueLazyload from 'vue-lazyload'
import App from './App.vue'
import store from './store'
import router from './router'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false

// スクロールイベントを作成
Vue.directive('scroll', {
  inserted: function (el, binding) {
    let f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f)
      }
    }
    window.addEventListener('scroll', f)
  }
})

Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1,
  lazyComponent: true,
  observer: true
})

Vue.use(ErrorPage, {
  resolver: (component) => {
    return require('./pages/' + component).default
  }
})

let vue = new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
})

window.eventBus = vue

vue.$mount('#app')
